import { render } from "./FollowUpTab.vue?vue&type=template&id=b6073a04"
import script from "./FollowUpTab.vue?vue&type=script&lang=js"
export * from "./FollowUpTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__